/*
 * @Description: 新增、编辑服务项目配置对话框中各面板共用的数据
 * @Author: sunhuihong
 * @Date: 2022-05-26 08:28:58
 * @LastEditTime: 2022-05-30 17:47:03
 */
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

const state = {
    mode: '',
    serviceCfgBaseInfoDO: {},
    serviceCfg: {
        timeRange: [],
    },
    svcTypeCfgDOList: {},
    modeMapCfg: {},//服务模式数据
    sloganList: [],
    userFile: null,
    serviceFile: null,
    timeRange: [],
    serviceItemCfgList: [],
    matterCfgBaseInfoDO: [],
    servicePkgCfgList: [],
}

const mutations = {
    changeMode(stateN, mode) {
        stateN.mode = mode;
    },

    changeServiceCfgBaseInfoDO(stateN, serviceCfgBaseInfoDO) {
        stateN.serviceCfgBaseInfoDO = serviceCfgBaseInfoDO;
    },

    changeServiceCfg(stateN, serviceCfg) {
        stateN.serviceCfg = serviceCfg;
    },

    changeUserFile(stateN, userFile) {
        stateN.userFile = userFile;
    },

    changeServiceFile(stateN, serviceFile) {
        stateN.serviceFile = serviceFile;
    },

    changeSvcTypeCfgDOList(stateN, svcTypeCfgDOList) {
        stateN.serviceCfg.category = stateN.mode == 'add' ? svcTypeCfgDOList[0].categoryType 
          : stateN.serviceCfg.category;
        stateN.svcTypeCfgDOList = svcTypeCfgDOList
    },

    changeModeMapCfg(stateN, modeMapCfg) {
        stateN.modeMapCfg = modeMapCfg
    },

    changeSloganList(stateN,sloganList) {
        stateN.sloganList = sloganList
    },

    changeServiceItemCfgList(stateN, serviceItemCfgList) {
        stateN.serviceItemCfgList = serviceItemCfgList;
    },

    changeMatterCfgBaseInfoDO(stateN, matterCfgBaseInfoDO) {
        stateN.matterCfgBaseInfoDO = matterCfgBaseInfoDO;
    },

    changeServicePkgCfgList(stateN, servicePkgCfgList) {
        stateN.servicePkgCfgList = servicePkgCfgList;
    },
}

export default new Vuex.Store({
    state: state,
    mutations: mutations
})


// WEBPACK FOOTER //
// ./src/components/hsvccfg/components/hsvcCfgDetails/HsvcCfgDetailStore.js